import { Contractor } from "@/types/contractor";

interface ContractorSchemaProps {
  contractor: Contractor;
  city: string;
  location: string;
  serviceType: string;
  businessSlug: string;
  imageUrl: string;
}

export const ContractorSchema = ({ 
  contractor, 
  city, 
  location, 
  serviceType, 
  businessSlug,
  imageUrl 
}: ContractorSchemaProps) => {
  const schemaData = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "@id": `https://homeprosokc.com/${location}/${serviceType}/${businessSlug}`,
    "name": contractor.name,
    "image": imageUrl,
    "telephone": contractor.phone,
    "url": contractor.website,
    "address": {
      "@type": "PostalAddress",
      "addressLocality": city,
      "addressRegion": "OK",
      "addressCountry": "US"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "addressCountry": "United States",
      "addressRegion": "Oklahoma"
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": contractor.rating,
      "reviewCount": contractor.review_count
    },
    "priceRange": "$$",
    "servesCuisine": contractor.service_type
  };

  return (
    <script type="application/ld+json">
      {JSON.stringify(schemaData)}
    </script>
  );
};